// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".amount[data-v-cab58762]{font-family:outfit-semi-bold;font-size:22px;line-height:1}", ""]);
// Exports
module.exports = exports;
